import { render, staticRenderFns } from "./addSupplierQuotaModal.vue?vue&type=template&id=ef663020&scoped=true&"
import script from "./addSupplierQuotaModal.vue?vue&type=script&lang=ts&"
export * from "./addSupplierQuotaModal.vue?vue&type=script&lang=ts&"
import style0 from "./addSupplierQuotaModal.vue?vue&type=style&index=0&id=ef663020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef663020",
  null
  
)

export default component.exports